
export const setTableGenerator = (state, data) => {
  state.date = {...data.date}
  state.tableGenerator = data.data
}
export const pushTableGenerator = (state, data) => {
  state.tableGenerator.push(data)
}
export const editStateTableGenerator = (state, data) => {
  const i = state.tableGenerator.findIndex(x => x.id == data.id)
  if(i >= 0) state.tableGenerator[i].state = data.state
}

export const setVisibleColumns = (state, data) => {
  state.visibleColumns = data
}
export const setDetailVisibleColumns = (state, data) => {
  state.detailVisibleColumns = data
}
